module.exports = __webpack_public_path__ + "8105db527c63cacd57efd2a238685c3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/3-star.svg
// module id = 975
// module chunks = 0